export default "__VITE_ASSET__DRlRTQtJ__"